import { supabase } from './supabase';

export const callFunction = async (name, options) => {
  const { data, error } = await supabase.functions.invoke(name, options);
  if (error) {
    let message = error.message || 'Eroare';
    try {
      const body = await error.context?.json?.();
      if (body?.error) message = body.error;
    } catch {
      message = error.message || 'Eroare';
    }
    throw new Error(message);
  }
  return data;
};
